import { render } from "./notifications-breadcrumb.vue?vue&type=template&id=1f79ce4e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__